(function () {
  'use strict';

  angular
    .module('app.account-credits', [])

    .component('accountCredits', {
      bindings: {
        device: '<'
      },
      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountCredits;
      }],
      /* @ngInject */
      controller: ["$scope", "$location", "AppService", "AccountService", "HttpService", function ($scope, $location, AppService, AccountService, HttpService) {
        var ctrl = this;

        AccountService.initAccount(ctrl);

        ctrl.$onInit = function () {

          $scope.device = ctrl.device;
          ctrl.loading = true;

          AppService.getParams()
            .then(function (params) {
              if (!params.Account.IsManagementCredits) {
                $location.path(ctrl.links.AccountHome);
              } else {
                loadData();
              }
            })
            .catch(function (error) {
              console.error(error);
            });

        };

        function loadData() {
          HttpService.get({
            url: '/Cart/Credit/Get',
            cache: false
          })
          .then(function (response) {
            ctrl.credits = response.results;
            ctrl.loading = false;
          })
          .catch(function (error) {
            console.error(error);
          });
        }

      }],
      controllerAs: 'accountCtrl'
    });

})();
